export default __webpack_public_path__ + "static/media/O-144.df565ede.png";